module.exports = __webpack_public_path__ + "static/img/s51.46657390.png";